export const Color = {
  orange: "#f47521",
};
